import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import dataEs from "./data/data_es.json";
import dataEn from "./data/data_en.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
  offset: 250,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [language, setLanguage] = useState("es");

  useEffect(() => {
    const loadData = language === "en" ? dataEn : dataEs;
    setLandingPageData(loadData);
  }, [language]);

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
  };

  return (
    <>
      <Navigation data={landingPageData.Nav} onLanguageChange={handleLanguageChange} />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <Team data={landingPageData.Team} />
      <About data={landingPageData.About} />
      {/* <Gallery data={landingPageData.Gallery} /> */}
      <Contact data={landingPageData.Contact} />
    </>
  );
};

export default App;
